import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { ButtonEditRendererComponent } from 'src/app/components/button-edit-render.components';
import { ShopFloorDataService } from 'src/app/services/shopFloorData.service';
import { AgGridAngular } from 'ag-grid-angular';
import { LanguageService } from 'src/app/services/language-service';
import { ButtonSaveRendererComponent } from 'src/app/components/button-save-render.components';
import { ButtonDeleteRendererComponent } from 'src/app/components/button-delete-render.components';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-master',
  templateUrl: './language-master.component.html',
  styleUrls: ['./language-master.component.scss']
})
export class LanguageMasterComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  languageform!: FormGroup;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  moduleList!: any[];
  pageList!: any[];
  subModuleList!: any[];
  filterPageList!: any[];
  languageList!: any[];
  productList!: any[];
  filteredModules!: any[];
  filteredPages!: any[];
  filteredSubModules!: any[];
  key!: any;
  gridApi!: any;
  gridColumnApi!: any;
  columnDefs!: any;
  labelPosition: 'before' | 'after' = 'after';
  public frameworkComponents: any;
  rowData: any[] = new Array();
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      minWidth: 100,
      filter: true
    }
  }
  dummyDate!: any[];
  isPage: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private languageService: LanguageService,
    private spinner: NgxSpinnerService,
    private sfdcService: ShopFloorDataService,
    public router: Router,
    public translater: TranslaterService,
    public translate: TranslateService
  ) {

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });

    this.frameworkComponents = {
      buttonEditRenderer: ButtonEditRendererComponent,
      buttonSaveRenderer: ButtonSaveRendererComponent,
      buttonDeleteRenderer: ButtonDeleteRendererComponent
    }
    this.columnDefs = [
      { headerName: 'LN', maxWidth: 280, valueGetter: "node.rowIndex + 1" },
      { headerName: 'Tag Name', maxWidth: 380, field: 'TagName' },

      { headerName: 'English', field: 'EnglishTranslationValue', editable: true },
      {
        headerName: 'Arabic',
        field: 'OtherTranslatedValue',
        editable: true,
        hide: true
      },
      {
        headerName: 'French',
        field: 'OtherTranslatedValue',
        editable: true,
        hide: true
      },
      {
        headerName: 'Spanish',
        field: 'OtherTranslatedValue',
        editable: true,
        hide: true
      },
      {
        headerName: 'German',
        field: 'OtherTranslatedValue',
        editable: true,
        hide: true
      },
      {
        headerName: 'Dutch',
        field: 'OtherTranslatedValue',
        editable: true,
        hide: true
      },
      { headerName: 'Actions', cellRenderer: 'buttonSaveRenderer', cellRendererParams: { onClick: this.onClickSave.bind(this), label: 'Save' }, maxWidth: 85, suppressMenu: true },
      // { headerName: '', cellRenderer: 'buttonDeleteRenderer', cellRendererParams: { onClick: this.onClickDelete.bind(this), label: 'Delete' }, maxWidth: 85, suppressMenu: true }
    ];

  }

  ngOnInit(): void {
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.getAllModules();
    this.getLangueges();
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.languageform.controls[controlName].hasError(errorName);
  }

  onChangeLanguage(data: any): void {
    const language = this.languageList.find(element => element.languageId === data.value);
    if (language.languageName === 'Arabic') {
      const columns = this.gridOptions.columnApi.getAllColumns();
      const valueColumnEn = columns.filter((column: any) => column.getColDef().headerName === "English")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnEn, false);
      const valueColumn = columns.filter((column: any) => column.getColDef().headerName === "Arabic")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumn, true);
      const valueColumnSpan = columns.filter((column: any) => column.getColDef().headerName === "Spanish")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnSpan, false);
      const valueColumnFren = columns.filter((column: any) => column.getColDef().headerName === "French")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnFren, false);
      const valueColumnGer = columns.filter((column: any) => column.getColDef().headerName === "German")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnGer, false);
      const valueColumnDut = columns.filter((column: any) => column.getColDef().headerName === "Dutch")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnDut, false);
      this.agGrid.api.sizeColumnsToFit();
    } else if (language.languageName === 'French') {
      const columns = this.gridOptions.columnApi.getAllColumns();
      const valueColumnEn = columns.filter((column: any) => column.getColDef().headerName === "English")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnEn, false);
      const valueColumn = columns.filter((column: any) => column.getColDef().headerName === "French")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumn, true);
      const valueColumnSpan = columns.filter((column: any) => column.getColDef().headerName === "Spanish")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnSpan, false);
      const valueColumnFren = columns.filter((column: any) => column.getColDef().headerName === "Arabic")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnFren, false);
      const valueColumnGer = columns.filter((column: any) => column.getColDef().headerName === "German")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnGer, false);
      const valueColumnDut = columns.filter((column: any) => column.getColDef().headerName === "Dutch")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnDut, false);
      this.agGrid.api.sizeColumnsToFit();
    } else if (language.languageName === 'Spanish') {
      const columns = this.gridOptions.columnApi.getAllColumns();
      const valueColumnEn = columns.filter((column: any) => column.getColDef().headerName === "English")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnEn, false);
      const valueColumn = columns.filter((column: any) => column.getColDef().headerName === "Spanish")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumn, true);
      const valueColumnSpan = columns.filter((column: any) => column.getColDef().headerName === "Arabic")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnSpan, false);
      const valueColumnFren = columns.filter((column: any) => column.getColDef().headerName === "French")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnFren, false);
      const valueColumnGer = columns.filter((column: any) => column.getColDef().headerName === "German")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnGer, false);
      const valueColumnDut = columns.filter((column: any) => column.getColDef().headerName === "Dutch")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnDut, false);
      this.agGrid.api.sizeColumnsToFit();
    } else if (language.languageName === 'German') {
      const columns = this.gridOptions.columnApi.getAllColumns();
      const valueColumnEn = columns.filter((column: any) => column.getColDef().headerName === "English")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnEn, false);
      const valueColumnGer = columns.filter((column: any) => column.getColDef().headerName === "German")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnGer, true);
      const valueColumn = columns.filter((column: any) => column.getColDef().headerName === "Spanish")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumn, false);
      const valueColumnSpan = columns.filter((column: any) => column.getColDef().headerName === "Arabic")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnSpan, false);
      const valueColumnFren = columns.filter((column: any) => column.getColDef().headerName === "French")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnFren, false);
      const valueColumnDut = columns.filter((column: any) => column.getColDef().headerName === "Dutch")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnDut, false);
      this.agGrid.api.sizeColumnsToFit();
    } else if (language.languageName === 'Dutch') {
      const columns = this.gridOptions.columnApi.getAllColumns();
      const valueColumnEn = columns.filter((column: any) => column.getColDef().headerName === "English")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnEn, false);
      const valueColumnDut = columns.filter((column: any) => column.getColDef().headerName === "Dutch")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnDut, true);
      const valueColumnGer = columns.filter((column: any) => column.getColDef().headerName === "German")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnGer, false);
      const valueColumn = columns.filter((column: any) => column.getColDef().headerName === "Spanish")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumn, false);
      const valueColumnSpan = columns.filter((column: any) => column.getColDef().headerName === "Arabic")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnSpan, false);
      const valueColumnFren = columns.filter((column: any) => column.getColDef().headerName === "French")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnFren, false);
      this.agGrid.api.sizeColumnsToFit();
    } else {
      const columns = this.gridOptions.columnApi.getAllColumns();
      const valueColumnEn = columns.filter((column: any) => column.getColDef().headerName === "English")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnEn, true);
      const valueColumn = columns.filter((column: any) => column.getColDef().headerName === "Spanish")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumn, false);
      const valueColumnSpan = columns.filter((column: any) => column.getColDef().headerName === "Arabic")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnSpan, false);
      const valueColumnFren = columns.filter((column: any) => column.getColDef().headerName === "French")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnFren, false);
      const valueColumnGer = columns.filter((column: any) => column.getColDef().headerName === "German")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnGer, false);
      const valueColumnDut = columns.filter((column: any) => column.getColDef().headerName === "Dutch")[0];
      this.gridOptions.columnApi.setColumnVisible(valueColumnDut, false);
      this.agGrid.api.sizeColumnsToFit();
    }
    this.getTransalatedLanguage();
  }

  initForm() {
    this.languageform = this.formBuilder.group({
      module: ['', []],
      submodule: ['', []],
      page: ['', []],
      tagName: ['', [Validators.required]],
      tagValue: ['', [Validators.required]],
      language: [],
      type: ['page']
    });
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
      console.log(data.BreadcrumList);
      this.getLangWords();
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
    // return false;
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getAllModules(): void {
    this.languageService.getAllModule().subscribe((data: any) => {
      this.moduleList = data.moduleList;
      this.languageform.get('module')?.patchValue(this.moduleList[0].moduleId);
      if (this.moduleList.length > 0) {
        this.filteredModules = this.moduleList.slice();
        this.getPages(this.moduleList[0]?.moduleId);
        const data = {
          value: this.moduleList[0]?.moduleId
        }
        this.filterSubmodule(data);
      }
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  getPages(moduleId: any): void {
    const key = {
      ModuleId: moduleId
    }
    this.languageService.GetAllPages(key).subscribe((data: any) => {
      this.pageList = data.pageList;

    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  filterSubmodule(data: any): void {
    this.subModuleList = [];
    this.pageList?.forEach(p => {
      if (p.parentId === data.value) {
        this.subModuleList.push(p);
      }
    });
    if (this.subModuleList.length > 0) {
      this.languageform.get('submodule')?.patchValue(this.subModuleList[0]?.pageId);
      this.filteredSubModules = this.subModuleList.slice();
      const data1 = {
        value: this.subModuleList[0]?.pageId
      }
      this.filterPage(data1);
    } else {
      this.languageform.get('submodule')?.reset();
      this.languageform.get('page')?.reset();
      this.rowData = [];
    }
  }

  filterPage(data: any): void {
    this.filterPageList = [];
    this.pageList?.forEach(p => {
      if (p.parentId === data.value) {
        this.filterPageList.push(p);
      }
    })
    if (this.filterPageList.length === 0) {
      this.filterPageList.push(this.pageList.find(p => p.pageId === data.value));
    }
    this.languageform.get('page')?.patchValue(this.filterPageList[0]?.pageId);
    this.filteredPages = this.filterPageList.slice();
    this.getTransalatedLanguage();
  }

  getLangueges(): void {
    this.languageService.getLanguages().subscribe((data: any) => {
      this.languageList = data.languageList;
      this.languageform.get('language')?.setValue(this.languageList[0]?.languageId);
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  onClickSave(data: any): void {
    if (this.languageform.get('type')?.value === 'page') {
      if (data.data.OtherTranslationId !== 0) {
        this.key = {
          TransactionType: 2,
          ModuleId: this.languageform.get('module')?.value,
          PageId: this.languageform.get('page')?.value,
          LanguageId: this.languageform.get('language')?.value,
          TagName: data.data.TagName,
          TranslatedValue: data.newValue,
          TranslationId: data.data.OtherTranslationId,
        }
      } else {
        this.key = {
          TransactionType: 1,
          ModuleId: this.languageform.get('module')?.value,
          PageId: this.languageform.get('page')?.value,
          LanguageId: this.languageform.get('language')?.value,
          TagName: data.data.TagName,
          TranslatedValue: data.data.OtherTranslatedValue,
        }
      }
    } else if(this.languageform.get('type')?.value === 'menu') {
      if (data.data.OtherTranslationId !== 0) {
        this.key = {
          TransactionType: 2,
          ModuleId: 0,
          PageId: 0,
          LanguageId: this.languageform.get('language')?.value,
          TagName: data.data.TagName,
          TranslatedValue: data.newValue,
          TranslationId: data.data.OtherTranslationId,
        }
      }else{
        this.key = {
          TransactionType: 1,
          ModuleId: 0,
          PageId: 0,
          LanguageId: this.languageform.get('language')?.value,
          TagName: data.data.TagName,
          TranslatedValue: data.data.OtherTranslatedValue
        }
      }
     
    }

    this.languageService.saveLanguage(this.key).subscribe((data: any) => {
      this.toaster.success('success', data.ErrorMessage);
      this.reset();
      this.getTransalatedLanguage();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  onClickDelete(data: any): void {
    const key = {
      TransactionType: 3,
      ModuleId: this.languageform.get('module')?.value,
      PageId: this.languageform.get('page')?.value,
      LanguageId: this.languageform.get('language')?.value,
      TagName: data.data.tagName,
      TranslatedValue: data.data.OtherTranslatedValue,
      TranslationId: data.data.OtherTranslationId === 0 ? '' : data.data.OtherTranslationId,
    }
    this.languageService.saveLanguage(key).subscribe((data: any) => {
      this.toaster.success('success', data.ErrorMessage);
      this.getTransalatedLanguage();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getTransalatedLanguage(): void {
    if (this.languageform.get('type')?.value === 'page') {
      if (this.languageform.get('page')?.value !== null) {
        const key = {
          ModuleId: this.languageform.get('module')?.value,
          PageId: this.languageform.get('page')?.value,
          LanguageId: this.languageform.get('language')?.value
        }
        this.languageService.getTranslatedLanguages(key).subscribe((data: any) => {
          this.rowData = data.translateList;
        }, (error: any) => {
          this.toaster.error('error', error.message);
        });
      } else {
        this.toaster.warning('Warning', 'Please select page');
      }
    } else {
      const key = {
        ModuleId: 0,
        PageId: 0,
        LanguageId: this.languageform.get('language')?.value
      }
      this.languageService.getTranslatedLanguages(key).subscribe((data: any) => {
        this.rowData = data.translateList;
      }, (error: any) => {
        this.toaster.error('error', error.message);
      });
    }
  }

  onSubmit(): void {
    var key: any;
    if (this.languageform.get('type')?.value === 'page') {
      key = {
        TransactionType: 1,
        ModuleId: this.languageform.get('module')?.value,
        PageId: this.languageform.get('page')?.value,
        LanguageId: this.languageform.get('language')?.value,
        TagName: this.languageform.get('tagName')?.value,
        TranslatedValue: this.languageform.get('tagValue')?.value,
      }
    } else {
      key = {
        TransactionType: 1,
        ModuleId: 0,
        PageId: 0,
        LanguageId: this.languageform.get('language')?.value,
        TagName: this.languageform.get('tagName')?.value,
        TranslatedValue: this.languageform.get('tagValue')?.value
      }
    }
    if (this.languageform.valid) {
      this.languageService.saveLanguage(key).subscribe((data: any) => {
        this.toaster.success('success', data.ErrorMessage);
        this.getTransalatedLanguage();
        this.reset();
      }, (error: any) => {
        this.toaster.error('Error', error.message);
      });
    }
  }
  reset(): void {
    this.languageform.get('tagName')?.reset();
    this.languageform.get('tagValue')?.reset();
  }
  dateAsYYYYMMDDHHNNSS(date: any): string {
    return date.getFullYear()
      + '-' + this.leftpad(date.getMonth() + 1, 2)
      + '-' + this.leftpad(date.getDate(), 2)
      + ' ' + this.leftpad(date.getHours(), 2)
      + ':' + this.leftpad(date.getMinutes(), 2)
      + ':' + this.leftpad(date.getSeconds(), 2);
  }
  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength)
      + String(val)).slice(String(val).length);
  }
  onRadioChange() {
    this.isPage = this.languageform.get('type')?.value === 'page' ? true : false;
    this.getTransalatedLanguage();
  }
  //==================================================================== Ag Grid code Here ==================================================================//
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

  }
  rowClicked(params: any) {
    params.node.setData({
      ...params.data,
      dirty: true
    });
  }

  onCellValueChanged(params: any) {
    const cell = params.api.getFocusedCell();
    if (params.oldValue !== params.newValue) {
      cell.column.colDef.cellStyle = { color: 'red', fontWeight: '550' };
    }
    params.api.refreshCells(cell);
  }

  getRowStyle(params: any) {
    if (params.data.dirty) {
      return { 'background-color': '#75e6b3' }
    } else {
      return { 'background-color': '#ffffff' }
    }
  }

}
